import React from 'react'

const JS_Essentials_Assignment_3 = () => {
  return (
    <div>
      <h1>JS EssentialsAssignment 3</h1>
    </div>
  )
}

export default JS_Essentials_Assignment_3
